<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="MAKING MIDCENTURY MODERN">
<div class="frontmatter">
<div class="recto">
<h1 class="title"><a id="index">MAKING <br/><span class="tgold">MIDCENTURY</span> <br/>MODERN</a></h1><a id="index">
<h3 class="author">Christopher Kennedy</h3>
<h4><span class="small">Photography by </span>J. Rockwell Seebach</h4>
<h4><span class="small">Foreword by </span>Barclay Butera</h4>
<img alt="Gibbs Smith Logo" src="images/logo.jpg"/>
</a></div><a id="index">
<div class="verso">
<p class="versotitle">MAKING MIDCENTURY MODERN</p>
<p>Digital Edition 1.0</p>
<p class="copyright">Text © 2017 Christopher Kennedy</p>
<p>Photographs © 2017 J. Rockwell Seebach except as noted otherwise.</p>
<p>All rights reserved. No part of this book may be reproduced by any means whatsoever
            without written permission from the publisher, except brief portions quoted for purpose
            of review.</p>
<p class="nobreak">Gibbs Smith</p>
<p class="nobreak">P.O. Box 667</p>
<p>Layton, Utah 84041</p>
<p class="nobreak">Orders: 1.800.835.4993</p>
<p>www.gibbs-smith.com</p>
<p>ISBN: 978-1-4236-4650-1</p>
</div>
</a></div><a id="index">
<div class="frontmatter">
<div class="dedication" title="Dedication">
<div class="mediaobject" title="Photo of author's father.">
<img alt="Photo of author's father." src="images/0001_dad.jpg"/>
</div>
<p>For my father (1920–2003), who was always ahead of his time &amp; </p>
<div class="mediaobject" title="Photo of author's mother.">
<img alt="Photo of author's mother." src="images/Marilyn_on_the_beach.jpg"/>
</div>
<p>For my mother (1944–2007), who was timeless &amp;</p>
<div class="mediaobject" title="Photo of vases.">
<img alt="Photo of vases." src="images/0036_MMM.jpg"/>
</div>
<p>For Palm Springs: consider this my love song.</p>
</div>
</div>
</a></div><a id="index">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?a62827d0